import { graphql } from '@teachino/shared-infrastructure';
import { materialDetailsFragment } from './material-details.fragment';

export const materialDetailsQuery = graphql(
  `
    query MaterialDetails($id: String!) {
      material(materialIdInput: { id: $id }) {
        ...MaterialDetails
      }
    }
  `,
  [materialDetailsFragment],
);
